import {
  FETCH_WALLET_CASHOUTS_DATA,
  FETCH_WALLET_CASHOUTS_SUCCESS,
  FETCH_WALLET_CASHOUTS_FAILURE,
  CREATE_WALLET_CASHOUT_DATA,
  CREATE_WALLET_CASHOUT_SUCCESS,
  CREATE_WALLET_CASHOUT_FAILURE,
  APPROVE_WALLET_CASHOUT_DATA,
  APPROVE_WALLET_CASHOUT_SUCCESS,
  APPROVE_WALLET_CASHOUT_FAILURE,
  REJECT_WALLET_CASHOUT_DATA,
  REJECT_WALLET_CASHOUT_SUCCESS,
  REJECT_WALLET_CASHOUT_FAILURE,
  COMPLETE_WALLET_CASHOUT_DATA,
  COMPLETE_WALLET_CASHOUT_SUCCESS,
  COMPLETE_WALLET_CASHOUT_FAILURE,
  CANCEL_WALLET_CASHOUT_DATA,
  CANCEL_WALLET_CASHOUT_SUCCESS,
  CANCEL_WALLET_CASHOUT_FAILURE,
  RESET_WALLET_CASHOUT_STATE,
} from "./actionTypes";

// Fetch all cashout requests
export const fetchWalletCashoutsData = (filters = {}) => ({
  type: FETCH_WALLET_CASHOUTS_DATA,
  payload: filters,
});

export const fetchWalletCashoutsSuccess = (data) => ({
  type: FETCH_WALLET_CASHOUTS_SUCCESS,
  payload: data,
});

export const fetchWalletCashoutsFailure = (error) => ({
  type: FETCH_WALLET_CASHOUTS_FAILURE,
  payload: error,
});

// Create cashout request
export const createWalletCashoutData = (data) => ({
  type: CREATE_WALLET_CASHOUT_DATA,
  payload: data,
});

export const createWalletCashoutSuccess = (data) => ({
  type: CREATE_WALLET_CASHOUT_SUCCESS,
  payload: data,
});

export const createWalletCashoutFailure = (error) => ({
  type: CREATE_WALLET_CASHOUT_FAILURE,
  payload: error,
});

// Approve cashout request
export const approveWalletCashoutData = (id, notes = "") => ({
  type: APPROVE_WALLET_CASHOUT_DATA,
  payload: { id, notes },
});

export const approveWalletCashoutSuccess = (data) => ({
  type: APPROVE_WALLET_CASHOUT_SUCCESS,
  payload: data,
});

export const approveWalletCashoutFailure = (error) => ({
  type: APPROVE_WALLET_CASHOUT_FAILURE,
  payload: error,
});

// Reject cashout request
export const rejectWalletCashoutData = (id, rejectionReason, notes = "") => ({
  type: REJECT_WALLET_CASHOUT_DATA,
  payload: { id, rejectionReason, notes },
});

export const rejectWalletCashoutSuccess = (data) => ({
  type: REJECT_WALLET_CASHOUT_SUCCESS,
  payload: data,
});

export const rejectWalletCashoutFailure = (error) => ({
  type: REJECT_WALLET_CASHOUT_FAILURE,
  payload: error,
});

// Complete cashout request
export const completeWalletCashoutData = (id, notes = "") => ({
  type: COMPLETE_WALLET_CASHOUT_DATA,
  payload: { id, notes },
});

export const completeWalletCashoutSuccess = (data) => ({
  type: COMPLETE_WALLET_CASHOUT_SUCCESS,
  payload: data,
});

export const completeWalletCashoutFailure = (error) => ({
  type: COMPLETE_WALLET_CASHOUT_FAILURE,
  payload: error,
});

// Cancel cashout request
export const cancelWalletCashoutData = (id) => ({
  type: CANCEL_WALLET_CASHOUT_DATA,
  payload: id,
});

export const cancelWalletCashoutSuccess = (data) => ({
  type: CANCEL_WALLET_CASHOUT_SUCCESS,
  payload: data,
});

export const cancelWalletCashoutFailure = (error) => ({
  type: CANCEL_WALLET_CASHOUT_FAILURE,
  payload: error,
});

// Reset state
export const resetWalletCashoutState = () => ({
  type: RESET_WALLET_CASHOUT_STATE,
});

